// eslint-disable-next-line import/prefer-default-export
export const SET_SIGNATURES_NUMBER = 'SET_SIGNATURES_NUMBER';
export const SET_PHOTO = 'SET_PHOTO';
export const SET_IS_MATCH = 'SET_IS_MATCH';
export const SET_ERROR = 'SET_CHECKIN_ERROR';
export const UPDATE_PETITION_FORM = 'UPDATE_PETITION_FORM';
export const SET_LOADING_STATUS_CHECK_IN = 'SET_LOADING_STATUS_CHECK_IN';
export const SET_SIGN_ON_LINE_NUMBER = 'SET_SIGN_ON_LINE_NUMBER';

export const GET_FIELD_REPORT_REQUEST = 'GET_FIELD_REPORT_REQUEST';
export const GET_FIELD_REPORT_SUCCESS = 'GET_FIELD_REPORT_SUCCESS';
export const GET_FIELD_REPORT_FAILURE = 'GET_FIELD_REPORT_FAILURE';

export const POST_FIELD_REPORT_REQUEST = 'POST_FIELD_REPORT_REQUEST';
export const POST_FIELD_REPORT_SUCCESS = 'POST_FIELD_REPORT_SUCCESS';
export const POST_FIELD_REPORT_FAILURE = 'POST_FIELD_REPORT_FAILURE';

export const MARK_AS_PHYSICALLY_CHECKED_IN_REQUEST = 'MARK_AS_PHYSICALLY_CHECKED_IN_REQUEST';
export const MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS = 'MARK_AS_PHYSICALLY_CHECKED_IN_SUCCESS';
export const MARK_AS_PHYSICALLY_CHECKED_IN_FAILURE = 'MARK_AS_PHYSICALLY_CHECKED_IN_FAILURE';

export const ASSIGN_PETITION_REQUEST = 'ASSIGN_PETITION_REQUEST';
export const ASSIGN_PETITION_SUCCESS = 'ASSIGN_PETITION_SUCCESS';
export const ASSIGN_PETITION_FAILED = 'ASSIGN_PETITION_FAILED';

export const INVALIDATE_PETITION_REQUEST = 'INVALIDATE_PETITION_REQUEST';
export const INVALIDATE_PETITION_SUCCESS = 'INVALIDATE_PETITION_SUCCESS';
export const INVALIDATE_PETITION_FAILED = 'INVALIDATE_PETITION_FAILED';
